import React, { useState } from "react"
import { observer } from "mobx-react"
import { Button, Flex, Modal, Typography } from "antd"

import googleAuthenticator from "@src/app/assets/icons/google-authenticator.png"
import { authStore } from "@src/app/authStore"
import { SettingsOTP } from "@src/pages/settingsOTP"
import css from "@src/pages/settingsSecurity/index.module.css"

export const Settings2Fa = observer(() => {
  const { isOtpEnabled, merchantInfo } = authStore
  const { Text } = Typography
  const [open, setOpen] = useState(false)
  const handleClose = () => setOpen(false)

  return (
    <Flex gap={24} vertical>
      <Text>
        Secure your account from intruders and activate two-factor protection
      </Text>
      <div
        style={{
          alignItems: "start",
          display: "flex",
          gap: "22px",
          justifyContent: "space-between",
          padding: "12px",
        }}
      >
        <img
          alt="google authenticator"
          className={css.googleAuthImage}
          src={googleAuthenticator}
        />
        <div className={css.googleAuth}>
          <p className={css.title2fa}>Google Authenticator</p>
          <div className={css.indicator}>
            <div
              className={
                isOtpEnabled
                  ? css.indicatorIcon_enable
                  : css.indicatorIcon_disable
              }
            ></div>
            <p
              className={
                isOtpEnabled
                  ? css.indicatorText_enable
                  : css.indicatorText_disable
              }
            >
              {isOtpEnabled ? "Enable" : "Disable"}
            </p>
          </div>
          <p className={css.textAccess}>
            Get your security code in the app even without internet access
          </p>
        </div>
        <div className={css.btnBlock}>
          <Button
            id="GENERATED_ID_SETTINGS2FA_BUTTON_VOID_1"
            onClick={() => setOpen(true)}
            size="large"
            type={isOtpEnabled ? "default" : "primary"}
          >
            {isOtpEnabled ? "Disable 2FA" : "Enable 2FA"}
          </Button>
          <Modal
            centered
            closable={false}
            footer={null}
            maskClosable={true}
            maskStyle={{
              backgroundColor: "#1C6C2A",
              opacity: 0.15,
            }}
            maskTransitionName=""
            onCancel={() => setOpen(false)}
            open={open}
            width={640}
          >
            <SettingsOTP onClose={handleClose} />
          </Modal>
        </div>
      </div>
    </Flex>
  )
})
